import apiClient from './client'
import type { ChatMessage, AIUsage } from '@/types'

export const chatApi = {
  enqueueMessage: async (assistantId: string, content: string): Promise<{ message_id: string }> => {
    const { data } = await apiClient.post(`/assistants/${assistantId}/chat`, { message: content })
    return data
  },

  pollForNewMessages: async (assistantId: string, lastMessageId?: string): Promise<ChatMessage[]> => {
    const params: Record<string, string> = { timeout: '25' }
    if (lastMessageId) params.after = lastMessageId
    const { data } = await apiClient.get(`/assistants/${assistantId}/chat/poll`, { params, timeout: 30000 })
    return data
  },

  getHistory: async (assistantId: string): Promise<ChatMessage[]> => {
    const { data } = await apiClient.get(`/assistants/${assistantId}/chat/history`)
    return data
  },

  getAIUsage: async (assistantId: string): Promise<AIUsage> => {
    const { data } = await apiClient.get(`/assistants/${assistantId}/chat/usage`)
    return data
  },
}
